import React, { memo } from 'react'
import { Field } from 'redux-form'
import InputField from 'shared/components/fields/InputField'
import CheckBoxField from 'shared/components/fields/CheckboxField'
import PhoneField from 'shared/components/fields/PhoneField'
import { mapOptions } from 'shared/helpers/utils'
import { UserFormAdapter, UserFormFields } from './UserForm.constants'
import InputFieldReplicateValue from './InputFieldReplicateValue'
import InputFieldUniqueValue from './InputFieldUniqueValue'
import { TGeneralInfoProps } from './UserForm.types'
import { IAccessScope } from 'reducers/Reducers.interfaces'
import { parseValueToSelectValue } from 'core/utils/helpers'

declare global {
  interface Window {
      email:any;
      user_name: string
  }
}

const GeneralInfo = memo(function (props: TGeneralInfoProps, any) {
  const { mode, samlLogin, user, accounts, localeList, change } = props
  accounts.sort((a, b) => a.name > b.name ? 1 : -1)
  const setLanguage = (value: any): void => {
    const accountLocale = accounts.find(account => account.id === value.id)?.locale
    const locale = localeList.locales.filter(locale => locale.id === accountLocale)[0]
    change(UserFormAdapter.name, UserFormFields.language, locale)
  }
  return (
    <>
    { props.profileAccessScope === IAccessScope.system && mode === 'create' && props.permissions.canManageSystemUser &&
       <Field
         id={UserFormFields.accessScope}
         name={UserFormFields.accessScope}
         type='text'
         label='common.form.systemUser'
         placeholder='common.form.systemUser'
         component={CheckBoxField}
       />
    }
      <Field
        id='first_name'
        name={UserFormFields.firstName}
        type='text'
        required
        label='common.form.firstName'
        placeholder='common.form.firstName'
        component={InputField}
      />
      <Field
        id='last_name'
        name={UserFormFields.lastName}
        type='text'
        required
        label='common.form.lastName'
        placeholder='common.form.lastName'
        component={InputField}
      />
      { (mode === 'create') &&
        <Field
          id='emailInput'
          name={UserFormFields.email}
          type='email'
          label='common.form.email'
          placeholder='common.form.email'
          required
          component={InputFieldReplicateValue}
        />
      }
      { (mode === 'create') &&
        <Field
          id='usernameInput'
          name={UserFormFields.username}
          type='text'
          label='common.form.username'
          placeholder='common.form.username'
          required
          component={InputFieldReplicateValue}
        />
      }

      { (mode === 'edit') &&
        <Field
          id='emailInput'
          name={UserFormFields.email}
          type='email'
          label='common.form.email'
          placeholder='common.form.email'
          required
          component={InputField}
        />
      }
      { (mode === 'edit') &&
        <Field
          id='usernameInput'
          name={UserFormFields.username}
          type='text'
          label='common.form.username'
          placeholder='common.form.username'
          required
          user={user}
          component={InputFieldUniqueValue}
        />
      }
      { (mode === 'edit') && (samlLogin) &&
        <Field
          id='samlUsernameInput'
          name={UserFormFields.samlUsername}
          type='text'
          label='common.form.samlUsername'
          placeholder='common.form.samlUsername'
          required
          component={InputField}
        />
      }

      <Field
        id='phoneInput'
        name={UserFormFields.phone}
        label='common.form.phone'
        placeholder='common.form.phone'
        component={PhoneField}
      />
    </>
  )
})

GeneralInfo.displayName = 'GeneralInfo'

export default GeneralInfo
